const OPTIMIZER_RESET_PATTERN = /optimizer reset/i;

/** Verbose planner_server / Theta* planning failure lines from nav.service journal. */
const PLANNER_FAILURE_PATTERN =
    /plugin failed to plan calculation to|plugin failed to plan through|Failed to obtain robot pose for planning|Could not transform the start or goal pose in the costmap frame|Planning algorithm .+ failed to generate a valid path|planner .+ is not a valid planner/i;

export const isOptimizerResetLogLine = (line: string) => OPTIMIZER_RESET_PATTERN.test(line);

export const isPlannerFailureLogLine = (line: string) => PLANNER_FAILURE_PATTERN.test(line);

export const navServiceLogLineClassName = (line: string): string => {
    if (isPlannerFailureLogLine(line)) {
        return " text-red-400";
    }
    if (isOptimizerResetLogLine(line)) {
        return " text-warning";
    }
    return "";
};
